import React from 'react';
import Table from '../../component/table/table'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Pagination from '@material-ui/lab/Pagination';
import { MDBContainer,  MDBRow, MDBCol} from "mdbreact";
import './location.css'
import {message} from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import {NavLink, withRouter,Redirect} from 'react-router-dom'
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import { CSVLink } from "react-csv";
import Input from '@material-ui/core/Input';
import {hasValue} from '../../validations/validations'

let headers = [
  { label: "#", key: "id" },
  { label: "Name", key: "name" },
];
 
let csvData = [
  { label: "id", key: "id" },
  { label: "name", key: "name" },
];

class location extends React.Component {
  
  state={
    location:[],
    location2:[],
    loading:true,
    refresh:false,
    search:"",
    page:1,
    pages:1,
    csvData:[]
  }

  constructor(props){
    super(props)
    this.csvLinkEl = React.createRef();
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }

  componentDidMount(){
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    } 
    this.getlocations(1)
    this.getlocationsWithoutPagenation()

  }


  getlocations = (page,search) =>{
    this.setState({loading:true})
    axios.get(`${BASE_END_POINT}location?page=${page}`,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("location   ",response.data)
      var data = response.data.data.map(item=>[item.id,item.name_ar,item.name_en,"action"])
      console.log("DATA   ",data)
      this.setState({
        loading:false,
        refresh:false,
        location:response.data.data,
        location2:data,
        page:response.data.page,
        pages:response.data.pageCount,
      })
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
      this.setState({loading:false,})
    })
  }
  getlocationsWithoutPagenation = (search) =>{
    let url = `${BASE_END_POINT}location/withoutPagenation/get`
    if(search){
      url = `${BASE_END_POINT}location/withoutPagenation/get?search=${search}`
    }
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("locations   ",response.data)
        csvData= response.data.data.map(item => {
          return {
            ...{id:item.id},
            ...{name:this.props.isRTL?item.name_ar:item.name_en},
          };
        });
        this.setState({csvData:csvData})
        console.log(csvData)
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
    })
  }

  deletelocation = (id) => {
    console.log("ID   ",id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}location/${id}`,{
     headers: {
       'Content-Type': 'application/json',
       'Authorization':`Bearer ${this.props.currentUser.token}`,
       'Accept-Language':this.props.isRTL?'ar':'en'
     },
    })
    .then(response=>{
      console.log("Year DELETED")
      l.then(() => message.success(allStrings.done, 2.5) )
      this.getlocations(this.state.page)
    })
    .catch(error=>{
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    })
 }

  addNewRecordButton = () =>(
    <div style={{width:'100%'}}>
      <NavLink to="Addlocation">
        <Fab
          style={{background:'#233b5b',float:'left',margin:'50px 30px'}}
          variant="extended"
          size="medium"
          color="primary"
          aria-label="add"
        >
          <AddIcon />{allStrings.addNewRecored}
        </Fab>
      </NavLink>
    </div>
  )

  paginationButtons = () =>(
    <CardActions style={{display: 'inline-flex'}}>
        <Button 
        onClick={()=>{
          if(this.state.page!==1){
            this.getlocations(1)
            this.setState({page:1})
          }
        }}
        className="pagenation" >{allStrings.first}</Button>

        <Button 
        onClick={()=>{
         if(this.state.page>1){
            this.getlocations(this.state.page-1)
            this.setState({page:this.state.page-1})
         }
        }}
        className="pagenation">{allStrings.prev}</Button>
        
        <Pagination
        onChange={(event,page)=>{
        console.log("page   ",page)
        if(page!==this.state.page){
          this.getlocations(page)
          this.setState({page:page})
        }
        
        }} 
        defaultPage={1} page={this.state.page} count={this.state.pages} style={{color:`#233b5b !important`}} />
        
        <Button 
        onClick={()=>{
          if(this.state.page<this.state.pages){
            this.getlocations(this.state.page+1)
            this.setState({page:this.state.page+1})
          }
        }}
        className="pagenation">{allStrings.next}</Button>

        <Button 
         onClick={()=>{
          if(this.state.page!==this.state.pages){
            this.getlocations(this.state.pages)
            this.setState({page:this.state.pages})
          }
        }}
        className="pagenation">{allStrings.last}</Button>

    </CardActions>
  )

  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('LOCATIONS')) return <Redirect to='/Home' />

  return (
    <div className="App">
        
      <MDBContainer> 
      <MDBRow>
        <MDBCol md="12">
          <div className="screenTable">
            
          <Table
          reload = {
            <span 
            style={{position: 'absolute',margin: '7px 0px',color: 'rgb(67, 66, 93)',fontWeight: '600',cursor: 'pointer'}}
            onClick={() => this.getlocations(1)}
            class="material-icons">
              replay
            </span>
          }
          csv = {
            <CSVLink 
                data={this.state.csvData} 
                headers={headers} 
                filename={"locations.csv"}
                ref={this.csvLinkEl}
              >
                <img crossOrigin="anonymous"alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
              </CSVLink>
          }
          searchInput = {
            <Input 
            onKeyPress={(e)=>{
              if (e.key === 'Enter') {
                if(hasValue(""+e.target.value)){
                  console.log("ENTER   ",e.target.value)
                  this.setState({search:e.target.value})
                  this.getlocations(1,e.target.value)
                  this.getlocationsWithoutPagenation(e.target.value)
                }else{
                  message.warning(allStrings.noValue);
                  console.log("ENTER NO VALUE   ",e.target.value)
                }
              }
             }}  
            placeholder={allStrings.Search} style={{direction:this.props.isRTL?'rtl':'ltr'}}inputProps={{ 'aria-label': 'description' }} />
          }
            title={allStrings.locations}
            icon='location_city'
            data={this.state.location}
            data2={this.state.location2}
            tableColumns={["#",allStrings.arabicName,allStrings.englishName,allStrings.action]}
            loading={this.state.loading}
            deleteButton={(id)=>{this.deletelocation(id)}}
            path='/locationInfo'
            actionIndex={3}
            />
            {this.paginationButtons()}
            {this.addNewRecordButton()}
            </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </div> 
  )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(location)
);

